import React, {useEffect} from 'react';
import { AnimationFadeToggle } from '../../../utils';

const ModalWrapper = ({isOpen, cssClass, children}) => {

    //Habilitar y deshabilitar scroll
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = null;
            }
        }
    }, [isOpen])

    return (
        <AnimationFadeToggle isOpen={isOpen}>
            {isOpen && 
                <section className={"modal " + cssClass}>
                    <div className="main-container">
                        {children}
                    </div>
                </section>
            }
        </AnimationFadeToggle>
    )
};

export default ModalWrapper;